module.exports = __webpack_public_path__ + "img/device-android-8212d9fc828f3a91ae0a516e846df44c.svg";